module.exports = __webpack_public_path__ + "img/loading.6f2fd65a.gif";